import { useQuery } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';

export interface Servico {
  id: string;
  slug: string;
  nome: string;
  descricao_curta?: string;
  descricao_longa?: string;
  categoria: string;
  ticket_minimo_brl?: number;
  ticket_tipico_brl?: number;
  sinais_de_fit?: string[];
  ativo: boolean;
  ordem: number;
}

export function useServicos() {
  return useQuery({
    queryKey: ['servicos'],
    queryFn: () => n8nFetch<Servico[]>('/servicos'),
  });
}
